/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import * as ApiService from '../../common/services/ApiService';

function getDistributionCenter(id, query) {
    return ApiService.get(true, `VendorDistributionCenters/${id}`, query);
}

export { getDistributionCenter };
